<script>
import resources from './resources'

export default {
  name: 'plu',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content.home
    page
    loading(
      :active.sync='loading',
      :can-cancel='true',
      :is-full-page='fullPage',
      color='#7159c1'
      )
    .container-fluid
      .block-header
        .row.clearfix
          .col-lg-5.col-md-5.col-sm-12
            h2 Pet
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Pet
              li.breadcrumb-item.active Listagem


          .col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                v-model="search.generic"
                @keyup.enter="doFilterSearch()"
                placeholder='Localizar pet'
              )
              //- Localizando
              span.input-group-addon.cursor-pointer(
                @click.prevent="doFilterSearch()",
                v-if="!search.generic")
                i.zmdi.zmdi-search
              //- Limpando filtro
              span.input-group-addon.cursor-pointer(
                @click.prevent="doClearSearch()",
                v-if="search.generic")
                i.zmdi.zmdi-close

      .row.clearfix(v-if="!loading")
        .col-lg-12.col-md-12.col-sm-12(style="height: 48px;")
          .card
            .header
              ul.header-dropdown
                li
                  router-link(:to="{ name: 'dweller.pets.create' }")
                    i.zmdi.zmdi-plus-circle
                    
        items(@on-delete='doDelete', v-for='pet in pets', :key='pet.id', :pet='pet')

      .row.clearfix
        pagination(:pagination="pagination", @pagination-changed-page="setPage")

</template>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.card .header .header-dropdown li .dropdown-menu {
    border-radius: .55rem;
    overflow: hidden;
    right: 0 !important;
    left: auto !important;
    transform: none !important;
    top: 30px !important;
    z-index: 3000;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/pets/index/index.vue